import React from 'react';
import { photoUrl } from '../../data/photos';
import { InnerHeroActions, InnerHeroTrust } from './InnerHeroActions';

export const ServicesHero = () => (
  <section className="inner-hero services-hero" data-testid="services-hero">
    <img className="inner-hero-photo" src={photoUrl('21')} alt="Blue BMW being serviced on a lift at the Desert Meadows shop" fetchPriority="high" data-testid="services-hero-photo" />
    <div className="inner-hero-shade" aria-hidden="true" />
    <div className="site-container inner-hero-content">
      <h1 data-testid="services-title">EVERYTHING YOUR CAR<br /><em>ASKS FOR.</em></h1>
      <p className="inner-hero-subtitle" data-testid="services-hero-subtitle">One shop, the whole job — no hand-offs, no mystery line items. Pick your service, or just call us.</p>
      <InnerHeroActions page="services" />
      <InnerHeroTrust page="services" />
    </div>
  </section>
);